@if (compact) {
  <a
    class="mobile-app-link mobile-app-link--compact"
    routerLink="/mobile-app"
    [attr.aria-label]="label"
    nz-tooltip
    [nzTooltipTitle]="compactTooltip"
  >
    <i nz-icon nzType="android" nzTheme="outline"></i>
  </a>
} @else {
  <div class="mobile-app-link">
    <a routerLink="/mobile-app">{{ label }}</a>
    @if (apkBuiltAt) {
      <div class="mobile-app-link__meta">Stand: {{ apkBuiltAt }}</div>
    }
    @if (showHint) {
      <p class="mobile-app-link__hint">Zum Installieren muss Android die Installation aus unbekannten Quellen erlauben.</p>
    }
  </div>
}
